(function() {
    let $section = $(".three-column-wrapper");
    $section.on('click', '.three-column-atc', function(event) {
        event.preventDefault();
        let $button = $(event.target).closest('.three-column-atc');
        let variant_id = $button.data('product-id');

        let data = {
            "id": variant_id,
            "quantity": 1
        }

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() { 
                window.SLIDECART_UPDATE(() => console.log('Cart updated!'))
                window.SLIDECART_OPEN();
            }
        });
    })
})();